<template>
<div class='ss-uploader-wrapper' :class="{'hide': !defaultBtn}">
  <slot>
    <el-button class='ssfileupload' :type="btnType" :plain="btnPlain" size='large' :disabled='onUploading'>
      {{onUploading ? onUploadingLabel : label}}
    </el-button>
  </slot>
</div>
</template>

<style lang='scss' scoped>
.ss-uploader-wrapper {
    position: relative;
    &.hover {
        .ssfileupload {
            background: $color-white-base;
            border-color: $color-primary;
            color: $color-primary;
        }
    }

    &.hide {
        width: 100%;
        height: 100%;
        opacity: 0;
        z-index: $index-top;
        position: absolute;
    }
}
</style>

<script>
import logger from '@/assets/scripts/logger'
import { lazyload } from '@/assets/scripts/lazy-load-module'

export default {
  data() {
    return {
      uploader: null,
      onUploading: false
    }
  },
  props: {
    label: {
      type: String,
      default: '本地上传'
    },
    onUploadingLabel: {
      type: String,
      default: '上传中...'
    },
    url: String,
    accept: String,
    extensions: Array,
    name: {
      type: String,
      default: 'file'
    },
    data: Object,
    btnType: {
      type: String,
      default: 'default'
    },
    btnPlain: {
      type: Boolean,
      default: true
    },
    defaultBtn: {
      type: Boolean,
      default: true
    },
    autoSubmit: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    onUploading: function(newValue) {
      this.$emit('update:uploading', newValue)
    }
  },
  methods: {
    init() {
      let vm = this
      lazyload('simple-ajax-uploader').then(ss => {
        vm.uploader = new ss.SimpleUpload({
          button: vm.$el,
          name: vm.name,
          debug: process.env.NODE_ENV !== 'production',
          url: vm.url,
          accept: vm.accept,
          autoSubmit: vm.autoSubmit,
          allowedExtensions: vm.extensions,
          nginxProgressUrl: `${process.env.API_ROOT}misc/fast_upload/progress`,
          responseType: 'json',
          hoverClass: 'hover',
          onSubmit: function(filename, extension, uploadBtn, filesize) {
            // update filename and filesize
            vm.$emit('update:filename', filename)
            vm.$emit('update:filesize', filesize && filesize * 1024)

            // set uploading state as true
            vm.onUploading = true

            // prepare for upload contained data
            this.setData(vm.data)
          },
          onChange: function(filename, extension, uploadBtn, filesize, file) {
            vm.$emit('change', {
              filename: filename,
              extension: extension,
              file: file
            })
          },
          onUpdateFileSize: function(filesize) {
            vm.$emit('update:filesize', filesize && filesize * 1024)
          },
          onComplete(filename, response, uploadBtn, filesize) {
            vm.onUploading = false
            vm.$emit('complete', response)
          },
          onExtError(filename, extension) {
            vm.$message({
              message: `暂不支持 ${extension} 文件，支持的格式为：${vm.extensions.join('，')}`,
              type: 'error'
            })
          },
          onError(filename, errorType, status, statusText, response, uploadBtn, filesize) {
            vm.onUploading = false
            // if return is 204, it would cause ssuploader error, but it is actually a successful issue
            if (status === 204) {
              vm.$emit('complete')
              return
            }
            logger.error(`ssuploader upload error: ${filename} - ${errorType} - ${status} - ${statusText} - ${response}`)

            // 上传失败
            // send message
            if (status === 413) {
              vm.$message({
                message: '上传文件超过限制大小',
                type: 'error'
              })
              return
            }

            // handle external
            try {
              let data = JSON.parse(response)
              vm.$message({
                message: (data && data.message) || '上传失败：未知原因',
                type: 'error'
              })
            } catch (e) {
              vm.$message({
                message: response || '上传失败：未知原因',
                type: 'error'
              })
            } finally {
              vm.$emit('error', {
                status: status,
                statusText: statusText,
                response: response
              })
            }
          },
          onProgress(pct) {
            vm.$emit('update:progress', pct)
          }
        })
      })
    },
    submit() {
      this.uploader.submit()
    }
  },
  mounted() {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// ss_uploader.input.vue?18772c40